// extracted by mini-css-extract-plugin
module.exports = {"annotation":"MileGifts_annotation__Jv_Ie","giftItem":"MileGifts_giftItem__LC68e"};